import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent, HttpEventType } from '@angular/common/http';
//import { HttpParamsOptions } from '@angular/common/http/src/params';
//import { ResponseContentType } from '@angular/http';

import { Observable, empty, throwError } from "rxjs";
import { map } from 'rxjs/operators';

import { DataService, LoginService } from "./base/data.service";
import { SettingsService, DBkeys } from '../../settings';
import { ToastrService } from 'ngx-toastr';

import { saveAs } from 'file-saver';
import * as FileSaver from 'file-saver';

import { FilterModel } from '../../models';

// https://github.com/cipchk/ngx-filesaver/blob/master/lib/src/filesaver.service.ts

const API_ENDPOINT = 'api/v1/exports/';

@Injectable({
  providedIn: 'root'
})
export class FileSaverService extends DataService {

  constructor(
    httpClient: HttpClient,
    loginService: LoginService,
    private readonly settingsService: SettingsService,
    private readonly toastrService: ToastrService
  ) {
    super(httpClient, loginService);
  }

  downloadFileWithObservable(query: string, data: any) : Observable<boolean> {

    return Observable.create((observer) => {
      var fileName: string;

      let headers = this.getAuthorisationHeader();
      headers = headers.set('timeout', '240000');

      //let params = this.convertToHttpParams(data);

      this.httpClient.post(API_ENDPOINT + query, data,
        {
          headers: headers,
          //params: params,
          responseType: 'blob', /*ResponseContentType.Blob.toString()*/
          observe: 'response',
        })
        .pipe(
          map((data: HttpEvent<object>) => {
            if (data.type === HttpEventType.Response) {

              fileName = this.getFilenameFromResponse(data);

              return data.body;
            }
          })
        )
        .subscribe((file: Blob) => {
          FileSaver.saveAs(file, fileName);

          observer.next(true);
          observer.complete();

        }, (error: any) => {

          //setTimeout(() => {
          //  this.toastrService.error(error && error.statusText ? error.statusText : error && error.status ? error.status : "General", 'Unexpected Error', { tapToDismiss: true });
          //});

          observer.next(false);
          observer.complete();
        });
    });
  }

  downloadFileWithAuth(reportName: string, filterModel: FilterModel) { // not tested
    if (this.getAuthorisationHeader() == null) {
      // return Observable.of(false);
      return throwError(new Error('Not Authorised'));
    }

    let headers = this.getAuthorisationHeader();
    headers = headers.set('timeout', '240000');

    let params = this.convertToHttpParams(filterModel);
    // params = params.append('subFleetID', this.settingsService.subFleetId.toString());// add some 

    return Observable.create((observer) => {
      this.httpClient.get(API_ENDPOINT + `report/${reportName}`,
        {
          headers: headers,
          params: params,
          responseType: 'blob',
          observe: 'response'
        })
        .subscribe(response => {

          observer.next(response);
          observer.complete();
        });

    });
  }

  getFilenameFromResponse(response): string {
    // "content-disposition" => attachment; filename=report.xlsx; filename*=UTF-8''report.xlsx
    let fileName = response.headers.get('content-disposition').split(';')[2].split('=')[1];
    fileName = fileName.replace("UTF-8''", '');
    fileName = decodeURIComponent(fileName);

    return fileName;
  }

  private convertToHttpParams(filterModel: any /* skip intellisense */) {
    const alteredParams = Object.assign({}, filterModel);// copy

    if (alteredParams.dateStart)
      alteredParams.dateStart = this.converToDateString(alteredParams.dateStart);
    if (alteredParams.dateEnd)
      alteredParams.dateEnd = this.converToDateString(alteredParams.dateEnd);

    let params = this.getParamsFromObject(alteredParams); // convert object

    return params;
  }

}
